import { Card, BlockStack, InlineStack, Text, Spinner, Box, Banner } from '@shopify/polaris';
import type { AdminStats } from '../../api/admin';

interface Props {
  stats: AdminStats | null;
  loading: boolean;
  error?: string | null;
}

function StatCard({ label, value, sub }: { label: string; value: string | number; sub?: string }) {
  return (
    <Card>
      <BlockStack gap="100">
        <Text as="p" variant="bodySm" tone="subdued">{label}</Text>
        <Text as="p" variant="heading2xl" fontWeight="bold">{value}</Text>
        {sub && <Text as="p" variant="bodySm" tone="subdued">{sub}</Text>}
      </BlockStack>
    </Card>
  );
}

export function AdminStatsCards({ stats, loading, error }: Props) {
  if (loading) {
    return (
      <Box padding="800">
        <InlineStack align="center"><Spinner /></InlineStack>
      </Box>
    );
  }
  if (error) {
    return <Banner tone="critical">{error}</Banner>;
  }
  if (!stats) return null;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
      <StatCard label="Total Shops"         value={stats.shops.total} sub={`${stats.shops.active} active`} />
      <StatCard label="Active Subscriptions" value={stats.active_subscriptions} />
      <StatCard label="AI Requests (30d)"    value={stats.ai_usage_30d.requests.toLocaleString()} sub={`$${stats.ai_usage_30d.cost_usd.toFixed(2)} cost`} />
      <StatCard label="Audits Run (30d)"     value={stats.audits_30d.toLocaleString()} />
    </div>
  );
}
